import React, { useState } from "react";

function HoarderCleanoutFAQs() {
  const [openAccordionIndex, setOpenAccordionIndex] = useState(null);

  const toggleAccordion = (index) => {
    // Toggle the current accordion's open state
    setOpenAccordionIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const accordionItems = [
    {
      title: "How much does a hoarder cleanout cost?",
      content: `
Pricing depends on the size and complexity of the job. We provide free, upfront quotes with no hidden fees.
      `,
    },
    {
      title: "Do you offer same-day service?",
      content: `
      Yes! We offer same-day and next-day appointments based on availability.
      `,
    },
    {
      title: "Do I need to be present during the cleanout?",
      content: `
       Not necessarily. We can follow your instructions even if you’re not there in person.
      `,
    },
    {
      title: "What do you do with the removed items?",
      content: `
         We donate usable items to local charities and recycle or dispose of the rest responsibly.
        `,
    },
    {
      title: "How do I book a hoarder cleanout?",
      content: `
           Simply call or message us for a free quote, schedule a time, and let us handle the rest!
          `,
    },
  ];

  return (
    <div>
      <main>
        <div className="accordion">
          {accordionItems.map((item, index) => (
            <div className="accordion-item" key={index}>
              <div
                className="accordion-item-header"
                onClick={() => toggleAccordion(index)}
                style={{ cursor: "pointer" }}
              >
                <span className="accordion-item-header-title">
                  {item.title}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                  />
                </svg>
              </div>
              <div
                className="accordion-item-description-wrapper"
                style={{
                  display: openAccordionIndex === index ? "block" : "none",
                }}
              >
                <div className="accordion-item-description furniture-faq">
                  <hr />
                  <p>{item.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default HoarderCleanoutFAQs;
